import { SESSION_PATH, withLanguageParam } from '@/services/languageParam';

/**
 * Tells the server the reader switched language, so the session answers in it from now on — the
 * refusals a cabinet form shows in the server's own words included.
 *
 * GET /api/v1/me with `lang`: a request that changes nothing but the session's language. A bare
 * fetch rather than apiGet, as reportPageView does: with nobody signed in it answers 401, which is
 * not an expired session to report nor an error to show — the public site switches language too.
 * It never throws and never rejects; the interface has already changed without waiting for it.
 *
 * Two limits, accepted. A request sent in the same instant as the switch may still be refused in the
 * old language, since the two race to the server. And the language belongs to the session, not to
 * the tab: two tabs set to different languages share one, and the last switch wins for both.
 */
export function announceLanguage(language: string): void {
  try {
    void fetch(withLanguageParam('GET', SESSION_PATH, language), {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'include',
    }).catch(() => {
      // Nothing to tell the reader: the next load carries the language anyway.
    });
  } catch {
    // fetch itself can throw synchronously where it is unavailable or blocked.
  }
}
